import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { Button, Typography } from '@cfa/react-components';

import { hasNumbersOnlyInString } from '@/utils/string';

import FilterSurface from '@/components/Filter/components/FilterSurface';

import { licenseeLocationAtom } from '@/atoms/licensee-location';

interface LicenseeLocationTriggerProps {
  className?: string;
  wrapFilterSurface?: boolean;
}

export const LicenseeLocationTrigger = ({
  className,
  wrapFilterSurface,
}: LicenseeLocationTriggerProps) => {
  const { t } = useTranslation();

  const [{ selected }, sendLicenseeLocationAction] =
    useAtom(licenseeLocationAtom);

  const showChangeLicenseeLocation =
    selected?.name && hasNumbersOnlyInString(selected.number);

  const renderLocationTrigger = () => (
    <>
      <div className="block md:hidden">
        <Button
          color="secondary"
          onClick={() => sendLicenseeLocationAction('show')}
          size="lg"
          variant="outlined"
        >
          {showChangeLicenseeLocation
            ? t('Licensee.changeLicenseeLocation', {
                locationNumber: selected.number,
              })
            : t('Generic.chooseLicenseeLocation')}
        </Button>
      </div>

      <div className="hidden flex-col gap-2 md:flex">
        <Typography fontWeight="bold" variant="body1" align="left">
          {t('Licensee.licenseeLocation')}
        </Typography>
        {showChangeLicenseeLocation && (
          <Typography variant="body1" align="left">
            {`${selected.number} ${selected.name}`}
          </Typography>
        )}
        <Button
          className="mb-0 w-fit"
          color="secondary"
          onClick={() => sendLicenseeLocationAction('show')}
          size="sm"
          variant="outlined"
        >
          {showChangeLicenseeLocation
            ? t('Generic.change')
            : t('Generic.choose')}
        </Button>
      </div>
    </>
  );

  return wrapFilterSurface ? (
    <FilterSurface className={className} dataTestId="filter-desktop-search">
      {renderLocationTrigger()}
    </FilterSurface>
  ) : (
    <div className={className}>{renderLocationTrigger()}</div>
  );
};
